/**
 * InsuranceIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const InsuranceIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.11 11.198a1 1 0 0 1 1.41 0l1.42 1.42 3.54-3.54a1 1 0 1 1 1.41 1.42l-4.24 4.24a1 1 0 0 1-1.42 0l-2.12-2.12a1 1 0 0 1 0-1.42" />
    <path
      fillRule="evenodd"
      d="m12.41 1.088 8 3.56a1 1 0 0 1 .59.91v5.35c0 5.45-3.71 10.56-8.73 11.93a.93.93 0 0 1-.54 0C6.71 21.468 3 16.358 3 10.908v-5.35a1 1 0 0 1 .59-.91l8-3.56a1 1 0 0 1 .82 0M12 20.838a10.53 10.53 0 0 0 7-9.93v-4.7l-7-3.11-7 3.11v4.7a10.53 10.53 0 0 0 7 9.93"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const InsuranceIcon = makeIcon('InsuranceIcon', InsuranceIconSvg)
